export const DEFAULT_USER_AVATAR = '/Images/User.png';

